import { Component } from '@angular/core';
import { HttpHeaders, HttpClient, HttpResponse } from '@angular/common/http';
import { DataLayerBaseComponent } from './data-layer-base.component';
import { MapService } from './map.service';
import { DataLayerService } from './data-layer.service';
import { ConfigService } from './config.service';
import { UserMessageService } from './user-message.service';

declare var L;

/*
 * data-layer-png defines a class to display png layers.
 *
 *
 * Within the configuration file, png layers can be included:
 * "overlayLayers": [
 * 		{"id": "radarLayer", "label": "Radar", "url": "https://tilecache.rainviewer.com/v2/radar/1562104800/256/{z}/{x}/{y}/5/1_1.png",
 *			"class": "data-layer-png",
 *			"legendUrl": "map/overlay-layers/FTG_N0R_Legend_0.gif", "refresh": true },
 * ...
 * ]
 *
 */

@Component({
	selector: 'data-layer-png',
	template: `
		<div class="checkboxDiv"><label class="overlay-layer">
		<input type="checkbox" (click)="menuControlSelected($event)">{{htmlElementLabel}}</label>
		<app-single-legend [active]=active [legendUrl]=legendUrl></app-single-legend>
		</div>
		`,
	styleUrls: ['app.component.css']
})
export class DataLayerPNGComponent extends DataLayerBaseComponent {
	http: HttpClient;
	opacity = .4;

	constructor(
		mapService: MapService,
		dataLayerService: DataLayerService,
		configService: ConfigService,
		userMessageService: UserMessageService,
		http: HttpClient) {
		super(mapService, dataLayerService, configService, userMessageService);
		this.http = http;
	}

	menuControlSelected (event): void {
		if ( event.target.checked ) {
			this.activateLayer();
		} else {
			this.deactivateLayer();
		}

	}

	// refreshLayer first checks to see if the layer is active.  If so, activateLayer is called.
	refreshLayer() {
		if ( this.active === true ) {
			this.activateLayer();
		}
	}

	setData ( someData: any ) {
		super.setData( someData );
		if ( someData.hasOwnProperty('opacity')) {
			this.opacity = someData.opacity;
		}
	}

	// First check whether the information has been read.
	// Display the png on the map and set the layer to active.
	activateLayer () {
		console.log('Activating ' + this.id + ' layer.');
		if ( this.mapLayer != null ) {
			this.mapService.map.removeLayer(this.mapLayer);
		}
		if ( this.value == null || this.refresh === true ) {
			// once the data file has been read, drawMarkers is automatically called because an observer has been established
			this.parseDataFile();
		}

		this.mapLayer = L.imageOverlay(this.value, {
			opacity: this.opacity,
		}).addTo(this.mapService.map).bringToFront();

		// activate legend as well
		const legendDisplay = this.mapService.getDataLayerLegendDisplay(this.id);
		if ( legendDisplay != null ) {
			legendDisplay['source'].next (true);
		}

		this.active = true;

	}

	deactivateLayer() {
		console.log('Deactivating ' + this.id + ' layer.');
		if ( this.active === true ) {
			this.mapService.map.removeLayer(this.mapLayer);
			this.active = false;
		}
		const legendDisplay = this.mapService.getDataLayerLegendDisplay(this.id);
		if ( legendDisplay != null ) {
			legendDisplay['source'].next (false);
			legendDisplay['display'] = false;
		}
	}

	parseDataFile () {
		console.log('In data-layer-png.parseDataFile.');
		if ( this.url.startsWith('http')) {
			this.value = this.url;
		} else {
			this.value = this.configService.baseDir + this.url + '?nocache=' + (new Date()).getTime();
		}
	}

}
